import { NgModule } from '@angular/core';
import {
  NbIconModule,
  NbSelectModule,
  NbListModule,
  NbSpinnerModule,
  NbPopoverModule,
  NbCardModule,
  NbButtonModule,
  NbTooltipModule,
} from '@nebular/theme';
import { AccountSelectionDropdownComponent } from './account-selection-dropdown.component';
import { ComponentsModule } from '../components.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CreateVcsAppV3Module } from '../create-vcs-app-integration-v3/create-vcs-app-integration-v3.module';

@NgModule({
  declarations: [AccountSelectionDropdownComponent],
  imports: [
    CommonModule,
    NbSelectModule,
    NbIconModule,
    NbListModule,
    NbSpinnerModule,
    NbPopoverModule,
    ComponentsModule,
    ReactiveFormsModule,
    NbCardModule,
    NbButtonModule,
    NbTooltipModule,
    CreateVcsAppV3Module,
  ],
  exports: [AccountSelectionDropdownComponent],
})
export class AccountSelectionDropdownModule {}
